import React from 'react';

export const fuzzyMatch = (text, query) => {
    if (!query || !query.trim()) return true;
    if (!text) return false;
    const t = String(text).toLowerCase();
    const q = query.toLowerCase().trim();
    const tokens = q.split(/\s+/).filter(Boolean);
    return tokens.every((tok) => t.includes(tok));
};

export const daysBadgeClasses = (days) => {
    if (days == null) return 'bg-gray-100 text-gray-700';
    if (days >= 14) return 'bg-red-100 text-red-700 border border-red-300';
    if (days >= 7) return 'bg-orange-100 text-orange-700 border border-orange-300';
    if (days >= 3) return 'bg-amber-100 text-amber-700 border border-amber-300';
    return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
};

export const DaysBadge = ({ days }) => (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded-sm ${daysBadgeClasses(days)}`}>
        {days != null ? `J+${days}` : '—'}
    </span>
);

export const OVERDUE_CATEGORIES = [
    { value: 'rdv', label: 'RDV sans devis', key: 'rdv_sans_devis', color: '#DC2626', summary: 'rdv_sans_devis' },
    { value: 'devis', label: 'Devis sans retour', key: 'devis_sans_retour', color: '#EA580C', summary: 'devis_sans_retour' },
    { value: 'relances', label: 'Relances en retard', key: 'relances_en_retard', color: '#D97706', summary: 'relances_en_retard' },
    { value: 'chantiers', label: 'Chantiers à réceptionner', key: 'chantiers_a_receptionner', color: '#2563EB', summary: 'chantiers_a_receptionner' },
    { value: 'silence', label: 'Clients silencieux', key: 'clients_silencieux', color: '#7C3AED', summary: 'clients_silencieux' }
];
